import React from 'react';
import BaseFormGrid from '../../components/grids/BaseFormGrid';
import { cloneDeep } from 'lodash';
import useSupplierTypeGrid from './hooks/useSupplierTypeGrid';
import { isNilOrEmpty } from '../../utils/objectUtils';
import booleanCellRenderer from '../../components/grids/cellRenderers/booleanCell.renderer';

const SupplierTypeGrid = () => {
    const {
        rowData,
        colDefs,
        canView,
        canCreate,
        canUpdate,
        redirectToForm,
        handleGridEdits,
    } = useSupplierTypeGrid();

    return (
        <BaseFormGrid
            title="Supplier Types"
            displayGrid={canView}
            isLoading={isNilOrEmpty(colDefs)}
            rowData={cloneDeep(rowData)}
            useRowDrag={canUpdate}
            sortKey={'sortOrder'}
            columnDefs={colDefs}
            gridClass="full-size-item"
            displayToolbar={true}
            displayCreateNewButton={canCreate}
            displayExportDataButton={true}
            displayResetStateButton={true}
            onCreateNew={redirectToForm}
            onRowClicked={({ data }) => redirectToForm(data)}
            onHandleGridEdits={handleGridEdits}
            frameworkComponents={{
                booleanCellRenderer: booleanCellRenderer,
            }}
        />
    );
};

export default SupplierTypeGrid;
